import { AccountOrganisationWebhook } from '@/service';

/**
 * @class @name UserInvitation
 * @description Exposes menu store module
 */
export default class UserInvitation {
	/**
	 * @method @static @get @name namespaced
	 * @description Is this module namespaced?
	 */
	static get namespaced() {
		return true;
	}

	/**
	 * @method @static @get @name state
	 * @description Expose state as an object, compatible with vue stores
	 */
	static get state() {
		return {};
	}

	/**
	 * @method @static @get @name getters
	 * @description Expose getters as an object, compatible with vue stores
	 */
	static get getters() {
		return {};
	}

	/**
	 * @method @static @get @name mutations
	 * @description Expose mutations as an object, compatible with vue stores
	 */
	static get mutations() {
		return {};
	}

	/**
	 * @method @static @get @name actions
	 * @description Expose action as an object, compatible with vue stores
	 */
	static get actions() {
		return {
			/**
			 * @async @name loadOrganisationWebhooks
			 * @description used to fetch organisation webhooks
			 * @param {function} commit
			 */
			async loadOrganisationWebhooks(context, id) {
				return AccountOrganisationWebhook.list(id);
			},

			/**
			 * @async @name addOrganisationWebhooks
			 * @description used to add organisation webhooks
			 * @param {function} commit
			 */
			async addOrganisationWebhooks(context, { id, payload }) {
				return AccountOrganisationWebhook.post(id, payload);
			}
		};
	}
}